window.addEventListener("load", function () {
  var el = document.querySelector("#Frame2 .swiper");
  if (!el) return;
  if (typeof Swiper === "undefined") return;

  new Swiper(el, {
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    navigation: {
      prevEl: "#Frame2 .prev",
      nextEl: "#Frame2 .next",
    },
    pagination: {
      el: "#Frame2 .swiper-pagination",
      clickable: true,
    },
  });
});
